export const preventEventForKeys = (keys: string[]) => (event: any) =>
  keys.includes(event?.key) ? event?.preventDefault() : undefined
